import Nav from "./components/Nav";
import WhatsAppChat from "./components/WhatsAppChat";
import AppRoutes from "./Routes";
import { BrowserRouter as Router } from "react-router-dom";

const App = () => (
  <Router>
    <main className="relative">
      <Nav />
      <AppRoutes />
      <WhatsAppChat />
    </main>
  </Router>
);

export default App;
